import React from "react";
import { Route, Redirect } from "react-router-dom";

const AppRoute = ({
	component: Component,
	layout: Layout,
	isAuthProtected,
	...rest
}) => {

	// console.log(rest.location.pathname);

	return (
		<Route
			{...rest}
			render={props => {

				if(localStorage.getItem("token") && ["/login", "/"].includes(rest.location.pathname)) {
					return (
						<Redirect to={{ pathname: "/dashboard", state: { from: props.location } }} />
					);
				}
				
				if (isAuthProtected && !localStorage.getItem("token")) {
					return (
						<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
					);
				}
				
				return (
					<Layout>
						<Component {...props} />
					</Layout>
				);
			}}
		/>
	);
		}
export default AppRoute;

